import React from "react";
import withView from '../../../cmn/docAutomation/withView';
import DashViewByGroupRow from './DashViewByGroupRow';
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormInput from '../../../../library/form/components/FormInput';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiViewHeading, UiTitle, UiAction } from "../../../../library/layout/Index";
import DashShortCuts from './DashShortCuts';
import SarasButton from '../../../../library/input/buttons/button/SarasButton';
import SarasChip from '../../../../library/repeater/list/SarasChip';
import DocSearchDynamicGroup from '../../../cmn/docSearch/components/DocSearchDynamicGroup';
import DocDynamicGroupTree from '../../../cmn/docSearch/components/DocDynamicGroupTree';

const DashViewByGroup = (props) => {
    const { formObject, sarasDnDManager, viewMap, groupData, groupKeys, groupDtId, deviceInfo,
        rowId, onFilterDateChange, onGroupDataChange, filterDate, groupHeight, groupClass, parentViewData,
        dragSpeedMenu, enableDynamicGroup, dynamicGroupManager, currentDynamicGroup, onClearDynamicGroup } = props;

    const onDateChange = (date) => {
        let customAction = {actionId: "show", actionMessage:"Refreshing Dashboard",
                    actionParam: {tdoctyid:groupDtId, sview:"D",viewDataReload:"1",dshv_rowId:rowId,cSDate:date,dynamicGroupKey:currentDynamicGroup || ""},
                    onSuccess: onSuccess }

        formObject.onFormAction(customAction, "", "");
    }

    const reloadData = (date) => {
        let customAction ={ actionId: "show", actionParam: {tdoctyid:groupDtId, sview:"D",viewDataReload:"1",dshv_rowId:rowId,cSDate:filterDate,dynamicGroupKey:currentDynamicGroup || ""},
        actionMessage:"Refreshing Dashboard", onSuccess: onSuccess }

        formObject.onFormAction(customAction, "", "");
    }

    const onSuccess = (action, containerKey, rKey, headerKey, response) => {
        // console.log("view group check", rowId, response);

        if(onFilterDateChange && filterDate !== action.actionParam.cSDate) onFilterDateChange(action.actionParam.cSDate);
        onGroupDataChange(response.mainViewData);
    }

    const renderDynamicGroup = () => {
        if (!enableDynamicGroup || !dynamicGroupManager) return null;

        const hasDynamicGroups = dynamicGroupManager.dynamicGroupData
            && Object.keys(dynamicGroupManager.dynamicGroupData).length > 0;

        if (!hasDynamicGroups) return null;

        return (
            <div>
                <DocSearchDynamicGroup
                    deviceInfo={deviceInfo}
                    dynamicGroupManager={dynamicGroupManager}
                />
            </div>
        );
    }

    const renderDynamicGroupChoice = () => {
        if (!enableDynamicGroup || !dynamicGroupManager || !dynamicGroupManager.hasDynamicGroupSelection) {
            return null;
        }

        return (
            <DocDynamicGroupTree
                dynamicGroupManager={dynamicGroupManager}
                deviceInfo={deviceInfo}
            />
        );
    }

    const renderSelectedDynamicGroup = () => {
        if (!enableDynamicGroup || !dynamicGroupManager || !dynamicGroupManager.hasDynamicGroupSelection) {
            return null;
        }

        const dynamicGroupData = dynamicGroupManager.dynamicGroupData || {};
        const selectedGroupKeys = Object.values(dynamicGroupManager.dynamicGroupSelection || {});
        const hasSelectedGroupDefinitions = selectedGroupKeys.every((groupKey) => dynamicGroupData[groupKey] && dynamicGroupData[groupKey].dataList);

        if (!hasSelectedGroupDefinitions) return null;

        const group = dynamicGroupManager.getSelectedGroupLabels();

        if (!group) return null;

        return (
            <div className='uiSelectedGroup'>
                <SarasChip className='uiSearchCriteriaChip' data={{ key: group, val: group }} onDelete={onClearDynamicGroup} />
            </div>
        );
    }

    const renderDynamicGroupControls = () => {
        const dynamicGroup = renderDynamicGroup();
        const selectedDynamicGroup = renderSelectedDynamicGroup();

        if (!dynamicGroup && !selectedDynamicGroup) return null;

        return (
            <div className='uiFlexBox3'>
                {dynamicGroup}
                {selectedDynamicGroup}
            </div>
        );
    }

    const renderBoardSurface = () => {
        return (
            <div
                className="uiSecContents uiDashBoardLaneScroller"
                id="dashGroupChoices"
                style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "stretch",
                    gap: "0px",
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: "100%",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                    {
                        groupKeys.map((rowKey, index) => (
                            <div key={index} className="uiDashBoardLaneCell" style={{ flex: "0 0 auto", height: "100%"}}>
                                <DashViewByGroupRow formObject={formObject} rowKey={rowKey} 
                                    viewMap={viewMap}
                                    viewData={groupData.viewRows[rowKey]} dashRowId={rowId} 
                                    reloadData={reloadData} groupHeight={groupHeight} groupClass={groupClass} 
                                    sarasDnDManager={sarasDnDManager}
                                />
                            </div>
                        ))
                    }
            </div>
        );
    }

    if (!groupData || !groupKeys)
        return (null)

    const hasDynamicGroup = enableDynamicGroup && dynamicGroupManager && dynamicGroupManager.hasDynamicGroupSelection;

    return (
        <div className="uiDashBoardSurface">
            <div className="uiDashBoardTopBand">
                <UiViewHeading>
                    <UiTitle>
                        {!deviceInfo.activateMobileView ? <SarasTrans value="View: " /> : null} <FormTitle formObject={formObject} value='' />
                    </UiTitle>
                    <UiAction>
                        <div className="uiDashBoardTopBandActions">
                            <FormWrapper customWrapper="div" wrapperClass="uiFlexBox3 uiDashBoardDateFilter" formObject={formObject} headerKey="actionButton" rowKey="" action={{ paramName: "calenderView" }} >
                                <span className="uiBold"><SarasTrans value = "Date Filter"/></span>
                                <FormInput formObject={formObject} rowKey="" headerKey="actionButton" 
                                    className="uiCalendarFlatLook" onChange={onDateChange}
                                    action={{ InputType: "dp", paramName: "calenderView" }}
                                />
                            </FormWrapper>
                            <FormButton formObject={formObject} ksc="r" rowKey=""
                                starIcon="refresh"
                                onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                                action={{ actionId: "show", actionParam: {tdoctyid:groupDtId, sview:"D",viewDataReload:"1",dshv_rowId:rowId,cSDate:filterDate,dynamicGroupKey:currentDynamicGroup || ""},
                                actionMessage:"Refreshing Dashboard", onSuccess: onSuccess }}
                                className="uiActionButton uiSpacerH10" text={<SarasTrans value="Refresh View" />}>
                            </FormButton>
                            <div className="uiDashBoardShortCutsWrap">
                                <DashShortCuts
                                    deviceInfo={deviceInfo}
                                    viewMap={viewMap}
                                    viewData={parentViewData}
                                    menuTrigger={
                                        <SarasButton
                                            className="uiContentCenter uiButtonAppText2 uiActionButton uiDashShortCutsTrigger"
                                            text={<SarasTrans value="Shortcuts" />}
                                        />
                                    }
                                />
                            </div>
                            <div>
                                {dragSpeedMenu}
                            </div>
                        </div>
                    </UiAction>
                </UiViewHeading>
                {renderDynamicGroupControls()}
            </div>
            <div className="uiDashContentLayer1 uiDashBoardLaneStrip" style={{position: "relative", top: "0px"}}>
                {hasDynamicGroup ? (
                    <div className='uiDocSearchLayout uiTwoColumn'>
                        {renderDynamicGroupChoice()}
                        <div className="uiResultViewColumn">
                            {renderBoardSurface()}
                        </div>
                    </div>
                ) : (
                    <div className='uiDocSearchLayout uiOneColumn'>
                        {renderBoardSurface()}
                    </div>
                )}
            </div>
        </div>
    )
}

export default withView(DashViewByGroup, "dashViews", "")
